import { getApiUrl } from "./api";
import {
  DEFAULT_GROUP_COVER_DATA_URL,
  DEFAULT_PROFILE_COVER_DATA_URL,
} from "./coverSvgs";

export const DEFAULT_PROFILE_COVER = "/assets/default-profile-cover.svg";
export const DEFAULT_GROUP_COVER = "/assets/default-group-cover.svg";

export {
  DEFAULT_PROFILE_COVER_DATA_URL,
  DEFAULT_GROUP_COVER_DATA_URL,
} from "./coverSvgs";

function resolveUploadedCover(coverImage) {
  if (!coverImage || typeof coverImage !== "string" || !coverImage.trim()) {
    return null;
  }
  if (coverImage.startsWith("http://") || coverImage.startsWith("https://")) {
    return coverImage;
  }
  return getApiUrl(`/uploads/${coverImage}`);
}

export function getProfileCoverUrl(coverImage) {
  return resolveUploadedCover(coverImage) || DEFAULT_PROFILE_COVER;
}

export function getGroupCoverUrl(coverImage) {
  return resolveUploadedCover(coverImage) || DEFAULT_GROUP_COVER;
}

function applyCoverFallback(event, fallback) {
  const el = event?.currentTarget;
  if (!el || el.dataset.coverFallback === "1") return;
  el.dataset.coverFallback = "1";
  el.src = fallback;
}

/** Use on profile cover `<img>` when the uploaded file is missing or deleted. */
export function onProfileCoverError(event) {
  applyCoverFallback(event, DEFAULT_PROFILE_COVER);
}

/** Use on group cover `<img>` when the uploaded file is missing or deleted. */
export function onGroupCoverError(event) {
  applyCoverFallback(event, DEFAULT_GROUP_COVER);
}
